export default "__VITE_ASSET__CY9_wcNg__"